import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import classnames from 'classnames';
import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal';
import 'normalize.css';
import '@/scss/main.scss';
import InputMaskPlugin from '@/directives/inputmask';
import { iwalyNotify } from './notify';
import { EventBus } from './event-bus';

Vue.config.productionTip = false;
Vue.prototype.$classnames = classnames;
Vue.prototype.$iwalyNotify = iwalyNotify;
Vue.prototype.$eventBus = EventBus;

Vue.use(Vuelidate);
Vue.use(VModal);
Vue.use(InputMaskPlugin);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
